export { default as LoadingDots } from './LoadingDots';
export * as Styled from './LoadingDots.styles';
